<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">CONTENTS</p>
<p class="toc"><a href="#/Acknowledgements">Acknowledgements</a></p>
<p class="toc"><a href="#/Introduction">Introduction</a></p>
<p class="toc1"><a href="#/Chapter1#C1">1. Christian Bachtle</a></p>
<p class="toc"><span href="#/Chapter2#C2" title="Link target outside of Sample">2. Amelia Richardson</span></p>
<p class="toc"><span href="#/Chapter3#C3" title="Link target outside of Sample">3. Triple Hanging</span></p>
<p class="toc"><span href="#/Chapter4#C4" title="Link target outside of Sample">4. Joseph Kline</span></p>
<p class="toc"><span href="#/Chapter5#C5" title="Link target outside of Sample">5. George McMillen</span></p>
<p class="toc"><span href="#/Chapter6#C6" title="Link target outside of Sample">6. Henry Popp</span></p>
<p class="toc"><span href="#/Chapter7#C7" title="Link target outside of Sample">7. Annie George</span></p>
<p class="toc"><span href="#/Chapter8#C8" title="Link target outside of Sample">8. James Cornelius</span></p>
<p class="toc1"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?34f67661